import React from 'react';
import { FieldArrayWithId} from 'react-hook-form';

// Redux

// Services
import { getTranslateByKey } from '@/main/services/utils';

// Types
import { DynamicReportForm } from '../../../registerDynamicReport';

// Api


// Components
import {
  Close as CloseIcon,
  Edit as EditIcon
} from '@mui/icons-material';
import BoxGrid from '@/main/components/shared/boxGrid/boxGrid';
import { IconButton, TableCell, TableRow } from '@mui/material';


import * as S from './styles';




interface IPermissionFieldProps {
  fields: FieldArrayWithId<DynamicReportForm, 'permissions', 'id'>[];
  startEdit: (permission: FieldArrayWithId<DynamicReportForm, 'permissions', 'id'>) => void;
  remove: (permission: FieldArrayWithId<DynamicReportForm, 'permissions', 'id'>) => void;
}

function PermissionList( { fields, startEdit, remove }: IPermissionFieldProps) {

  const sizeCollumns = [
    '30%', // CompanyType,
    '60%', // Company,
    '80px'  // Actions
  ];

  const rowHeaders = [
    getTranslateByKey('information.companyType'),
    getTranslateByKey('information.company'),
    '' // Actions
  ];




  return (
    <S.PermissionGridArea>
      <BoxGrid
        rowHeaders={rowHeaders}
        sizeColumns={sizeCollumns}
        widthCustom='100%'
      >
        {
          fields.map((permission) => {
            return (
              <TableRow
                id={`id-dynamicReport-PermissionList-${permission.id}`}
                key={permission.id}
              >
                <TableCell>{permission.companyType?.value}</TableCell>
                <TableCell>{permission.allCompanies ? getTranslateByKey('information.all')  : permission.company?.value}</TableCell>
                <TableCell>
                  <S.AreaActions>
                    <IconButton
                      key={permission.id + 'edit'}
                      id={`id-dynamicReport-PermissionList-edit-${permission.id}`}
                      onClick={() => startEdit(permission)}
                    >
                      <EditIcon/>
                    </IconButton>
                    <IconButton
                      key={permission.id + 'remove'}
                      id={`id-dynamicReport-PermissionList-remove-${permission.id}`}
                      onClick={() => remove(permission)}
                    >
                      <CloseIcon/>
                    </IconButton>
                  </S.AreaActions>
                </TableCell>
              </TableRow>
            );
          })
        }
      </BoxGrid>
    </S.PermissionGridArea>
  );
}


export default PermissionList;